import React, { useRef } from 'react';
import PropTypes from 'prop-types';

export default function Pill(props) {
  let { type, label, emphasis, tooltip } = props;
  const pillRef = useRef();
  const tooltipRef = useRef();

  const hoverPill = () => {
    if (tooltip) {
      const pillTop = pillRef.current.offsetTop;
      const pillLeft = pillRef.current.offsetLeft;
      const pillWidth = pillRef.current.clientWidth;
      if (tooltipRef.current) {
        const tooltipHeight = tooltipRef.current.clientHeight;
        tooltipRef.current.style.top = `${pillTop - tooltipHeight - 5}px`;
        tooltipRef.current.style.left = `${pillLeft + pillWidth / 2}px`;
      }
    }
  };
  return (
    <div
      className={`km__c--pill km__c--pill-is-${type} ${
        emphasis ? 'km__c--pill-has-emphasis' : ''
      }`}
      ref={pillRef}
      onMouseEnter={hoverPill}
    >
      {label}
      {tooltip && (
        <div className='km__c--pill-tooltip' ref={tooltipRef}>
          {tooltip}
        </div>
      )}
    </div>
  );
}
Pill.propTypes = {
  label: PropTypes.string,
  emphasis: PropTypes.bool,
  tooltip: PropTypes.string,
  type: PropTypes.oneOf([
    'default',
    'primary',
    'attention',
    'success',
    'important',
    'new',
  ]),
};
Pill.defaultProps = {
  type: 'default',
  emphasis: false,
};
